import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';

// helpers
import { toggleDrawer } from '../../helpers/helpers.js'

const ExamFlags = observer(class ExamFlags extends React.Component {
  constructor() {
    super();

    this.state = {
      expanded: false
    }
  }

  showSession(e, student) {
    let { pathname } = this.props.routing.location;

    toggleDrawer(e, this.props.parent, 'SessionDetail');

    pathname += `?session=${student.sessionSid}`;
    this.props.routing.push(pathname);
  }

  toggle = () => {
    this.setState({
      expanded: !this.state.expanded
    });
  }

  render() {
    const { translation, flags } = this.props;
    const { userTimezone } = this.props.store.SessionStore;


    return (
      <section
        id="automated-flags-report"
        className="panel__section"
        tabIndex="-1"
      >
        <h2
          className="panel__heading panel__heading--expand"
          onClick={this.toggle}
        >
          {translation.heading}

          <button
            id="automated-flags-report-control"
            className={`
              btn--expand
              ${this.state.expanded ? 'expanded' : ''}
            `}
            onClick={this.toggle}
            aria-controls="automated-flags-report-container"
            aria-expanded={this.state.expanded}
          >
            <span className="meta">{translation.view_details}</span>
          </button>
        </h2>

        <div
          id="automated-flags-report-container" 
          className={this.state.expanded ? 'expanded' : 'collapsed'}
        >
          {flags.students.length > 0 &&
            <table>
              <caption className="meta">{translation.heading}</caption>
              <thead>
                <tr>
                  <th className={`subtitle column-studentName`} scope="col">{translation.headings.studentName}</th>
                  <th className={`subtitle column-dateSessionClosed`} scope="col">{translation.headings.dateClosed}</th>
                  <th className={`subtitle column-flags`} scope="col">{translation.headings.flags}</th>
                  <th className={`subtitle column-flagDetails`} scope="col">{translation.headings.flagDetails}</th>
                  <th className={`subtitle column-action`} scope="col">{translation.headings.action}</th>
                </tr>
              </thead>
              <tbody>
                {flags.students.map(
                  (row, i) =>
                  <tr key={i}>
                    <td className={`column-studentName`}>
                      {row.studentName}
                    </td>
                    <td className={`column-dateSessionClosed`}>
                      {moment.utc(row.dateSessionClosed)
                        .tz(userTimezone)
                        .format('M/D/YYYY [at] h:mma z')}
                    </td>
                    <td className={`column-flags`}>
                      {row.timesOccurred}
                    </td>
                    <td className={`column-flagDetails`}>
                      <ul className="simple-list">
                        {row.annotations.map(
                          (ev, j) =>
                          <li key={j}>
                            {`${ev.annotationName}: ${ev.timesOccurred}`}
                          </li>
                        )}
                      </ul>
                    </td>
                    <td className="actions">
                      <button className="btn--outline" onClick={(e) => this.showSession(e, row)}>
                        {translation.show_session}
                      </button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          }
        </div> 
      </section>
    )
  }
})

export default translate('ExamFlags')(ExamFlags);



// WEBPACK FOOTER //
// ./src/app/components/ExamDashboard/ExamFlags.js